import React, { useState, useEffect } from "react";
import { WifiOff, X } from "lucide-react";

const NoInternetAlert = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showAlert, setShowAlert] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowAlert(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowAlert(true);
    };

    // Add event listeners for real-time detection
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Fallback polling every 5 seconds
    const pollInterval = setInterval(() => {
      const currentlyOnline = navigator.onLine;
      setIsOnline(currentlyOnline);
      setShowAlert(!currentlyOnline);
    }, 5000);

    // Cleanup
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      clearInterval(pollInterval);
    };
  }, []);

  if (!showAlert) return null;

  return (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50">
      <div className="bg-white border-2 border-red-500 rounded-lg shadow-lg p-3 max-w-sm mx-4 relative">
        {/* Close button */}
        <button
          onClick={() => setShowAlert(false)}
          className="absolute top-1 right-1 text-gray-600 hover:text-gray-800 transition-colors"
        >
          <X size={12} />
        </button>

        {/* Icon and content */}
        <div className="flex items-center gap-2">
          <div className="flex-shrink-0">
            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
              <WifiOff size={12} className="text-white" />
            </div>
          </div>

          <div className="flex-1">
            <h3 className="text-xs font-semibold text-gray-800 mb-0.5">
              No Internet Connection
            </h3>
            <p className="text-xs text-gray-600 leading-tight">
              Connection issue detected. Please check your internet and ensure your system is online.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoInternetAlert;
